const PREFIX = 'SOURCES';

export const LIST_SOURCES = `${PREFIX}/LIST`;
export const LIST_PARENT_SOURCES = `${PREFIX}/LIST_PARENT`;
export const RETRIEVE_SOURCE = `${PREFIX}/RETRIEVE`;
